import Vue from 'vue'
import isNumber from './is-number'

function heightToCorrectSystem(height, unitSystem) {
  if (!height && height !== 0 && height !== 0.0) {
    return ''
  }

  if (!isNumber(height)) {
    return height
  }
  const convertedHeight = Number(unitSystem.metersToCorrectSystem(height))

  if (!convertedHeight && convertedHeight !== 0) {
    return null
  }

  return unitSystem.isImperial ? `${Math.round(convertedHeight)}` : `${convertedHeight.toFixed(2)}`
}

function weightToCorrectSystem(weight, unitSystem) {
  if (!weight && weight !== 0 && weight !== 0.0) {
    return ''
  }

  if (!isNumber(weight)) {
    return weight
  }

  const convertedWeight = unitSystem.kilogramsToCorrectSystem(weight)

  if (!convertedWeight && convertedWeight !== 0) {
    return null
  }

  return `${Math.round(convertedWeight)}`
}

/**
 * Filter to convert a given value into unitSystems default value,
 * i.e., convert kg into pounds if unitSystem's system is 'imperial'
 *
 * @param {Number} value
 * @param {UnitSystem} unitSystem
 * @param {String} unitType
 */
function convertUnitToCorrectSystem(value, unitSystem, unitType) {
  switch (unitType) {
    case 'height':
      return heightToCorrectSystem(value, unitSystem)
    case 'weight':
      return weightToCorrectSystem(value, unitSystem)
    default:
      return value
  }
}

Vue.filter('convertUnitToCorrectSystem', convertUnitToCorrectSystem)
export default convertUnitToCorrectSystem
